import React, { useContext, useEffect, useState } from "react";
import scrollToElement from "scroll-to-element";

export const FilterContext = React.createContext();

const initialState = {
	position: "",
	voivodeship: "",
	location: "",
	mode: [],
	ruling: false,
};

const FilterProvider = ({ children }) => {
	const [filters, setFilters] = useState(initialState);

	const resetFilters = () => {
		setFilters({
			position: "",
			voivodeship: "",
			location: "",
			mode: [],
			ruling: false,
		});
		window.history.pushState({}, "", window.location.pathname);
	};

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const location = params.get("location");
		const voivodeship = params.get("voivodeship");

		const newState = filters;

		if (location) {
			newState.location = location;
		}

		if (voivodeship) {
			newState.voivodeship = voivodeship;
		}

		if (location || voivodeship) {
			setFilters(newState);
			scrollToElement("#list");
		}
	}, []);

	return (
		<FilterContext.Provider
			value={{
				filters: filters,
				setFilters: setFilters,
				resetFilters: resetFilters,
			}}
		>
			{children}
		</FilterContext.Provider>
	);
};

const useFilters = () => useContext(FilterContext);
export { useFilters };
export default FilterProvider;
